export enum LenderStatusEnum {
  NOTIFIED = 'Notified',
  REVIEWING = 'Reviewing',
  TENDER = 'Tender',
  DECLINED = 'Declined',
  NDA = 'NDA',
}
